export default {
  install (Vue) {

    const delegates = {
      'el-select': (component, element) => {
        return [component.$refs.reference.$el]
      },
      'el-pagination': (component, element) => {
        console.log(component, element)
        const sizesComponent = component.$children.find((child) => child.$options._componentTag === 'sizes')
        const eles_ElSelectInSizes = delegates['el-select'](sizesComponent.$children[0], element)
        return eles_ElSelectInSizes
      },
      'el-date-editor': (component, element) => {
        return [component.$refs.reference.$el]
      },
      'el-popover': (component, element) => {
        console.log(component, element)
        return [component.referenceElm]
      }
    }

    const getRefEles = (component, element) => {
      const tagName = component.$options._componentTag
      const delegate = delegates[tagName]
      console.log(`TagName for fix-zoom : ${ tagName }`)
      return delegate ? delegate(component, element) : [element] // 默认返回当前元素
    }

    Vue.directive('fixZoom', {
      inserted: function (element, binding, vnode) {
        const refEles = getRefEles(vnode.componentInstance, element)
        if (!refEles) {
          return
        }
        refEles.forEach((refEle) => {
          refEle.getBoundingClientRectBak = refEle.getBoundingClientRect
          refEle.getBoundingClientRect = function () {
            const rect = refEle.getBoundingClientRectBak()

            var zoom = window.getComputedStyle(document.body).zoom
            // var scrollTop = document.documentElement.scrollTop
            // var scrollLeft = document.documentElement.scrollLeft
            // var offsetScrollTop = scrollTop - (scrollTop / zoom)
            // var offsetScrollLeft = scrollLeft - (scrollLeft / zoom)

            // let left = rect.right / zoom - rect.width
            // let top = rect.bottom / zoom - rect.height
            let left = rect.left / zoom
            let top = rect.top / zoom

            // console.log(rect, left, top, refEle)

            // return rect
            return new DOMRect(left, top, rect.width, rect.height)
            // return new DOMRect(rect.x, rect.y, rect.width, rect.height)
          }
        })
      }
    })
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/js/fix-zoom.js
// module id = null
// module chunks = 